<template>
  <CardContent
    v-if="groups.length > 1"
    class="aside-subchapters"
    theme="neutral-50"
    aspect="square"
    stroke="m"
    elevate="none"
  >
    <template #header>
      <Heading align="left" tag="h4" icon="summary">
        Tous les contenus
      </Heading>
    </template>
    <div class="content">
      <section v-for="group in groups" :key="group.title" class="group">
        <h5 class="group-title">{{ group.title }}</h5>
        <ul>
          <li v-for="item in group.items" :key="item.id">
            <ButtonBase
              :key="item.slug"
              stroke="n"
              size="small"
              rounded
              theme="secondary"
              variant="outlined"
              :to="basePath + item.slug"
            >
              {{ item.title }}
            </ButtonBase>
          </li>
        </ul>
      </section>
    </div>

    <template #footer><span /></template>
  </CardContent>
</template>
<script setup lang="ts">
import { getServices } from '~/db/services';

const {
  categoryManager: { category },
  currentContent,
} = inject(INJECT_CATEGORY_PAGE);

const emit = defineEmits(["ready"]);

const { $db } = useNuxtApp();

const { categoriesService } = getServices($db);

const items = ref<CategorySchema[]>([]);

const route = useRoute();

const basePath = computed(() => {
  return route.path.split(category.value.slug)[0];
});

const groups = computed(() => {
  if (items.value.length === 0) return [];
  const mItems: Map<string, { title: string; items: CategorySchema[] }> =
    new Map();
  items.value.forEach((item: CategorySchema) => {
    if (item?.children?.length) {
      const groupLabel = item.groupLabel;
      if (!mItems.has(groupLabel)) {
        mItems.set(groupLabel, {
          title: groupLabel,
          items: [],
        });
      }
      mItems.get(groupLabel).items.push(item);
    }
  });
  return Array.from(mItems.values());
});

onBeforeMount(async () => {
  if (
    !category.value.chapterId ||
    !category.value.disciplineId ||
    !category.value.parentId
  ) {
    emit('ready');
    return;
  }

  const categories =
    await categoriesService.findByDisciplineIdChapterIdParentIdAndSubChapter(
      category.value.disciplineId,
      category.value.chapterId,
      category.value.parentId,
      currentContent.value.id
    );
  if (categories.length === 0) {
    emit('ready');
  } else {
    items.value = categories;
  }
});

watch(
  () => items.value.length,
  (length) => {
    if (length > 0) {
      requestAnimationFrame(() => emit('ready'));
    }
  }
);
</script>
<style lang="scss" scoped>
.aside-subchapters {
  @include below('l') {
    display: none;
  }

  // @include desktop {
  //   display: flex;
  // }
}
.content {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  gap: var(--gap_n);
}
.group {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  gap: var(--gap_s);
}

ul {
  display: flex;
  flex-wrap: wrap;
  gap: var(--gap_xs);
}
</style>
